import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { MentorService } from '../../services/account/mentor.service';
import { MentorResponse } from '../../models/account/mentor/mentorResponse';
import { ActivatedRoute } from '@angular/router';
import { Gender, GenderDescriptions } from '../../models/enums/enums';
import { UserSelectors } from '../../states/user/user-selector';
import { of, switchMap } from 'rxjs';
import { Store } from '@ngxs/store';
import { UserStateModel } from '../../states/user/user-state-model';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';


declare global { interface Window { Calendly: any; } }


@Component({
  selector: 'app-schedule-acall',
  standalone: true,
  imports: [FormsModule, CommonModule,CalendarModule, DropdownModule, DialogModule, ButtonModule],
  templateUrl: './schedule-acall.component.html',
  styleUrl: './schedule-acall.component.scss'
})
export class ScheduleACallComponent implements OnInit, OnDestroy {

  visible: boolean = false;
  index: number | undefined;

    showDialog() {
      this.visible = true;

    }

  date: Date | undefined = new Date();

  mentorDetail: MentorResponse | undefined;
  mentorId: string | undefined;
  user: UserStateModel | undefined;
  genders: { name: string; value: number }[] = [];

  constructor(
    private mentorService: MentorService,
    private route: ActivatedRoute,
    private store: Store
  ) {
    this.mentorId = this.route.snapshot.paramMap.get('id') || '';
  }

  @ViewChild('container') container!: ElementRef;

  ngOnInit(): void {
    window.addEventListener('message', this.calendlyEventListener);
    this.initilizeCalendly();
    this.genders = [
      { name: 'Male', value: 1 },
      { name: 'Female', value: 2 },
      { name: 'Other', value: 3 }
    ]
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.calendlyEventListener);
  }

  calendlyEventListener = (e: any) => {
    if (this.isCalendlyEvent(e)) {
      if (e.data.event === 'calendly.event_scheduled') {
        // Optionally, update your app state or call an API
      }
    }
  };

  isCalendlyEvent(e: any) {
    return e.data && e.data.event && e.data.event.startsWith('calendly');
  }

  genderDescriptions(arg0: Gender | undefined): string {
    if (arg0) {
      return GenderDescriptions[arg0];
    }
    else {
      return '';
    }
  }

  initilizeCalendly() {
    this.store.select(UserSelectors.getUser).pipe(switchMap(user => {
      if (!user || !user.id) {
        return of(null);
      }
      this.user = user;
      return this.mentorService.getMentorScheduleURI(this.mentorId??'');
    })).subscribe({
      next: response => {
        if (response != null && response!='') {
          window.Calendly.initInlineWidget({
            url: `${response}/30min?hide_gdpr_banner=1`,
            parentElement: document.querySelector('.calendly-inline-widget'),
            prefill: {
              "name": this.user?.firstName + ' ' + this.user?.lastName,
              "email": this.user?.email,
              "customAnswers": {
                "a1": "GradPilots Mentor Meeting",
              }
            }
          });
        }
      }
    });
  }
}
